import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiBackendService } from './fi-backend.service';
import { FiBackendCacheService } from '@fi-shared/fi-backend/fi-backend-cache.service';

@NgModule({
    imports: [CommonModule],
    providers: [FiBackendService, FiBackendCacheService],
})
export class FiBackendSharedModule {}
